(() => {
  "use strict";

  class GalleryModal {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.items = (window.GalleryData && window.GalleryData[sectionId]) || [];
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.isAnimating = false;

      this.modal = document.getElementById(`GalleryModal-${sectionId}`);
      this.grid = document.getElementById(`GalleryGrid-${sectionId}`);

      if (!this.modal || !this.grid || this.items.length === 0) return;

      this.content = this.modal.querySelector(".gallery-modal__content");
      this.image = this.modal.querySelector(".gallery-modal__image");
      this.description = this.modal.querySelector(
        ".gallery-modal__description",
      );

      this._bindEvents();
    }

    _bindEvents() {
      this.grid.querySelectorAll(".gallery-grid__item").forEach((btn) => {
        btn.addEventListener("click", () => {
          const index = parseInt(btn.dataset.galleryIndex, 10);
          this.open(index);
        });
      });

      this.modal.querySelectorAll("[data-gallery-close]").forEach((el) => {
        el.addEventListener("click", () => this.close());
      });

      this.modal.addEventListener("click", (e) => {
        if (
          !e.target.closest(".gallery-modal__content") &&
          !e.target.closest(".gallery-modal__nav")
        ) {
          this.close();
        }
      });

      const prevBtn = this.modal.querySelector("[data-gallery-prev]");
      const nextBtn = this.modal.querySelector("[data-gallery-next]");
      if (prevBtn) prevBtn.addEventListener("click", () => this._navigate(-1));
      if (nextBtn) nextBtn.addEventListener("click", () => this._navigate(1));

      document.addEventListener("keydown", (e) => {
        if (this.modal.hidden) return;
        if (e.key === "Escape") this.close();
        if (e.key === "ArrowLeft") this._navigate(-1);
        if (e.key === "ArrowRight") this._navigate(1);
      });

      this.modal.addEventListener(
        "touchstart",
        (e) => {
          this.touchStartX = e.touches[0].clientX;
          this.touchStartY = e.touches[0].clientY;
        },
        { passive: true },
      );

      this.modal.addEventListener(
        "touchend",
        (e) => {
          const dx = e.changedTouches[0].clientX - this.touchStartX;
          const dy = e.changedTouches[0].clientY - this.touchStartY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            this._navigate(dx > 0 ? -1 : 1);
          }
        },
        { passive: true },
      );
    }

    open(index) {
      this.currentIndex = index;
      this._updateContent();
      this.modal.hidden = false;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.modal.classList.add("gallery-modal--open");
        });
      });

      document.body.style.overflow = "hidden";
      this.modal.querySelector(".gallery-modal__close").focus();
    }

    close() {
      this.modal.classList.remove("gallery-modal--open");

      const onEnd = () => {
        this.modal.hidden = true;
        document.body.style.overflow = "";
        this.content.removeEventListener("transitionend", onEnd);
      };
      this.content.addEventListener("transitionend", onEnd);
    }

    _navigate(direction) {
      if (this.isAnimating) return;
      this.isAnimating = true;

      const imageWrapper = this.content.querySelector('.gallery-modal__image-wrapper');
      const info = this.content.querySelector('.gallery-modal__info');

      imageWrapper.style.opacity = '0';
      info.style.opacity = '0';

      setTimeout(() => {
        this.currentIndex =
          (this.currentIndex + direction + this.items.length) % this.items.length;
        this._updateContent();
        imageWrapper.style.opacity = '1';
        info.style.opacity = '1';
        setTimeout(() => {
          this.isAnimating = false;
        }, 250);
      }, 200);
    }

    _updateContent() {
      const item = this.items[this.currentIndex];
      if (!item) return;

      this.image.src = item.imageSrc;
      this.image.alt = item.imageAlt || "";

      this.description.textContent = item.description || "";
    }
  }

  function initGalleries() {
    if (!window.GalleryData) return;
    Object.keys(window.GalleryData).forEach((sectionId) => {
      new GalleryModal(sectionId);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGalleries);
  } else {
    initGalleries();
  }
})();
